import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { ErrorMessageProps } from "./types";

/**
 * Component to display error messages in the FileInput
 */
const ErrorMessage: React.FC<ErrorMessageProps> = ({ error }) => {
  return (
    <Stack
      component={Typography}
      variant="body2"
      alignItems="center"
      marginRight={1}
      marginTop={1}
    >
      <ErrorOutlineIcon fontSize="small" color="inherit" />
      {error}
    </Stack>
  );
};

export default ErrorMessage;
